// 9fbef606107a605d69c0edbcd8029e5d
export const ACCOUNT_MYPLACE_REWARDS = 'account.myPlaceRewards';
export const lblPointsClaimErrorInternal = 'lbl_points_claim_error_INTERNAL_SERVER_ERROR';
export const lblPointsClainError = 'lbl_points_claim_error';

const labelsObj = {
  account: {
    myPlaceRewards: {
      referred: [
        {
          name: 'Bonus Points Days Details',
          contentId: '804fb668-dcd8-4f2d-97b9-0c071d8e787a',
          __typename: 'ReferredContent',
        },
        {
          name: 'plcc-rewards-table',
          contentId: 'd8ca71a2-9ff0-48de-881b-229149429156',
          __typename: 'ReferredContent',
        },
      ],
      lbl_my_rewards_heading: 'My Rewards',
      ACC_LBL_MY_REWARDS_NO_REWARDS_MSG:
        'There are no coupons in your wallet. Start shopping to earn points and rewards! ',
      lbl_my_rewards_no_available_rewards: 'There are no available rewards. ',
      lbl_my_rewards_start_shopping: 'Start shopping to earn points!',
      lbl_my_rewards_point_balance: 'Points Balance',
      lbl_place_rewards_day: 'DAY',
      lbl_bonus_points_available_today: 'AVAILABLE TODAY!',
      lbl_bonus_points_used_on: 'USED ON',
      lbl_bonus_points_future_use: 'AVAILABLE FOR FUTURE USE',
      lbl_my_rewards_points_history: 'Points History',
      lbl_my_rewards_used_all: "You've used all your available Bonus Points Days.",
      lbl_bonus_points_daysLeft: 'You have {0} day left. ',
      lbl_bonus_points_bonusPointsDay: 'BONUS POINTS DAY',
      lbl_my_rewards_wallet_heading: 'AVAILABLE REWARDS & OFFERS',
      lbl_my_wallet_heading: 'MY WALLET',
      lbl_points_claim_transaction_type: 'Transaction Type',
      lbl_points_claim_store_number: 'Store Number',
      lbl_points_claim_register_number: 'Register Number',
      lbl_points_claim_transaction_date: 'Transaction Date',
      lbl_points_claim_transaction_number: 'Transaction Number',
      lbl_points_claim_order_date: 'Order Date',
      lbl_points_claim_account_number: 'My Place Rewards #:',
      lbl_points_claim_firstname: 'First Name:',
      lbl_points_claim_lastname: 'Last Name:',
      lbl_points_claim_email: 'Email:',
      lbl_points_claim_supporting_text:
        'Please fill out the information below to claim point from a recent purchase.',
      lbl_points_claim_heading: 'POINTS CLAIM',
      lbl_points_claim_submit_caps: 'SUBMIT REQUEST',
      lbl_points_claim_success_message:
        'Thank you for contacting us regarding your missing points. Please allow 48-72 hours to process your request. If more information is needed, a customer service representative will contact you.',
      lbl_points_claim_error:
        'Thank you for contacting us regarding your missing points. The transaction needs further verification before it can be assigned to your myPLACE Rewards account. Please allow 48-72 hours for a customer care representative to contact you.',
      lbl_points_claim_error_INTERNAL_SERVER_ERROR: 'Internal Server Error',
      lbl_points_claim_sample_receipt: 'SAMPLE RECEIPT',
      lbl_err_ordernumber: 'Please enter the order number',
      lbl_showMemberId: 'SHOW MEMBER ID',
      lbl_coupon_applyToBagtest: 'Make My Default List ',
    },
  },
};

export default labelsObj;
